import axios from '../request/http.js'
import { handleGetRequestParams } from '../common/js/utils.js'

class Salary {
  /* 获取模板列表 */
  static getSalaryTmpList() {
    let url = `/zzd/api/back/salary/template/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 保存模板 */
  static postSaveSalaryTmpList(data) {
    let url = `/zzd/api/back/salary/template/save`
    return axios.post(url,data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除模板 */
  static postDelSalaryTmp(data) {
    let url = `/zzd/api/back/salary/template/del`
    return axios.post(url,data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 分类列表 */
  static getSalaryTypeList(salaryTemplateId) {
    let url = `/zzd/api/back/salary/category/list?salaryTemplateId=${salaryTemplateId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 新增分类 */
  static postAddSalaryType(data) {
    let url = `/zzd/api/back/salary/category/add`
    return axios.post(url,data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 重命名分类 */
  static postModSalaryTypeName(data) {
    let url = `/zzd/api/back/salary/category/rename`
    return axios.post(url,data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除分类 */
  static postDelSalaryType(data) {
    let url = `/zzd/api/back/salary/category/del`
    return axios.post(url,data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 保存细项 */
  static postSaveDetails(data) {
    let url = `/zzd/api/back/salary/item/save`
    return axios.post(url,data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除细项 */
  static postDelDetails(data) {
    let url = `/zzd/api/back/salary/item/del`
    return axios.post(url,data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取工资列表 */
  static getSalaryList(month) {
    let url = `/zzd/api/back/payroll/list?month=${month}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 作废 */
  static postSalaryFormNullify(data) {
    let url = `/zzd/api/back/payroll/invalid`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除 */
  static postDelSalaryForm(data) {
    let url = `/zzd/api/back/payroll/delete`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 撤回审批 */
  static postSalaryFormWithdrawalApproval(data) {
    let url = `/zzd/api/back/payroll/approval/withdraw`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 工资表详情 */
  static getSalaryFormDetails(id) {
    let url = `/zzd/api/back/payroll/info?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 工资条列表 */
  static getPaySlipList(options) {
    let url = `/zzd/api/back/pay/slip/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 撤回工资条 */
  static postWithdraw(data) {
    let url = `/zzd/api/back/pay/slip/withdraw`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 发送单个工资条 */
  static postSendPaySlip(data) {
    let url = `/zzd/api/back/pay/slip/send`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 发送所有工资条 */
  static postSendAllPaySlip(data) {
    let url = `/zzd/api/back/pay/slip/send/all`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 工资条详情 */
  static getPaySlipDetials(id) {
    let url = `/zzd/api/back/pay/slip/detail?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 接收人列表 */
  static getSelectRecipientList() {
    let url = `/zzd/api/back/payroll/list/user`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 下载导入模板 */
  static downloadSalaryTmp(options) {
    let url = `/zzd/api/back/salary/download/template?`
    return axios.post(url, options, { responseType: 'blob' }).then(res => {
      return Promise.resolve(res);
    });
  }
  /* 导入模板 */
  static exportSalaryTmp(data) {
    let url = `/zzd/api/back/salary/upload/template`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取审批流程 */
  static getApprovalList() {
    let url = `/zzd/api/back/salary/approval/list`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 根据模板id和角色类型查询用户 */
  static getRoleType(templateId, roleType) {
    let url = `/zzd/api/back/salary/approval/list/by/templateId?templateId=${templateId}&roleType=${roleType}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 保存流程 */
  static postSaveApproval(data) {
    let url = `/zzd/api/back/salary/approval/save`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 删除流程 */
  static postDelApproval(data) {
    let url = `/zzd/api/back/salary/approval/del`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 制表人管理范围（树结构）  */
  static getTabulator() {
    let url = `/zzd/api/back/payroll/group/scope`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 根据部门id查询成员 */
  static getMember(id, queryStr) {
    let url = `/zzd/api/back/user/list/by/dept?id=${id}&queryStr=${queryStr}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 工资条保存 */
  static postSavePaySlip(data) {
    let url = `/zzd/api/back/pay/slip/save`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 发起审批 */
  static postInitiateApproval(data) {
    let url = `/zzd/api/back/payroll/approval/start`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取制表人所管理的三级部门 */
  static getThirdDeptment() {
    let url = `/zzd/api/back/salary/template/list/group`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取模板信息（分类、细项、解读内容）— 供制表编辑使用 */
  static getModSalaryTypeList(payrollId) {
    let url = `/zzd/api/back/pay/slip/category/list?payrollId=${payrollId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取工资条信息 — 供制表编辑使用 */
  static getModSalaryInfo(payrollId) {
    let url = `/zzd/api/back/pay/slip/item/list?payrollId=${payrollId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取模板信息（分类、细项、解读内容）— 供制表复制使用 */
  static getCopySalaryTypeList(payrollId) {
    let url = `/zzd/api/back/salary/category/copy/data?payrollId=${payrollId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取工资条信息 — 供制表复制使用 */
  static getCopySalaryInfo(payrollId) {
    let url = `/zzd/api/back/pay/slip/item/copy/data?payrollId=${payrollId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 导入模板--编辑工资条 */
  static modExportSalaryTmp(data) {
    let url = `/zzd/api/back/pay/slip/upload/template`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 流程记录 */
  static getProcedureRecord(id) {
    let url = `/zzd/api/back/payroll/list/process?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 工资条打印 */
  static getPrintData(id) {
    let url = `/zzd/api/back/payroll/print/data?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 生成费用单 */
  static postCreateExpense(data) {
    let url = `/zzd/api/back/order/bill/add/salary`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Salary;